import { useEffect } from "react";
import { Typography, Form, Select } from "antd";
import { setPreference, initialState } from "Components/Report/reportSlice";
import { useAppSelector, useAppDispatch } from "store/hook";
import { accountOptions, deviceOptions } from "Components/Report/OnDemand/Filter";

const { Title } = Typography;

const Layout = ({ type }: { type: "account" | "device" }) => {
  const [form] = Form.useForm();
  const { preference } = useAppSelector((state) => state.report);
  const disp = useAppDispatch();
  const SingleColumnOptions = type === "account" ? accountOptions : deviceOptions;

  useEffect(() => {
    form.setFieldsValue({
      column: preference["column"][type],
    });
  }, [preference["column"]]);

  return (
    <>
      <Title level={5} underline>
        Layout
      </Title>

      <Form form={form} layout="vertical">
        <div className="formwrap">
          <Form.Item name="column" label="Column" initialValue={2}>
            <Select
              onChange={(value: number) => {
                const newPreference = { ...preference, column: { ...preference["column"], [type]: value } };

                if (value === 2) {
                  disp(
                    setPreference({
                      ...newPreference,
                      order: { ...preference["order"], [type]: initialState.preference.order[type] },
                    })
                  );
                } else {
                  disp(
                    setPreference({
                      ...newPreference,
                      order: { ...preference["order"], [type]: [SingleColumnOptions.map((o) => o.value), []] },
                    })
                  );
                }
              }}
            >
              <Select.Option value={1}>1</Select.Option>
              <Select.Option value={2}>2</Select.Option>
            </Select>
          </Form.Item>
        </div>
      </Form>
    </>
  );
};

export default Layout;
